@import '../../../theme.scss';

verdocs-disclosure-dialog {
  /* Content styles specifically for disclosure dialog */
  .heading {
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: center;

    .close-button {
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 4px;
      border-radius: 50%;
      color: var(--verdocs-close-button-color, #6b7280);
      transition: all 0.2s ease;

      &:hover {
        background-color: var(--verdocs-close-button-hover-bg, #f3f4f6);
        color: var(--verdocs-close-button-hover-color, #111827);
      }

      svg {
        fill: currentColor;
      }
    }
  }

  .content {
    ul {
      list-style: none;
      /* Remove default bullets */
      padding: 0;
      margin: 0 0 16px 0;

      li {
        position: relative;
        padding-left: 34px;
        margin-bottom: 12px;
        font-size: 14px;
        line-height: 20px;

        &::before {
          content: '';
          position: absolute;
          left: 0;
          top: -2px;
          width: 24px;
          height: 24px;
          background-color: var(--verdocs-bullet-color, #707070);
          // Use masking to allow recovering the icon via background-color
          -webkit-mask-image: url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4.53033 12.9697C4.23744 12.6768 3.76256 12.6768 3.46967 12.9697C3.17678 13.2626 3.17678 13.7374 3.46967 14.0303L7.96967 18.5303C8.26256 18.8232 8.73744 18.8232 9.03033 18.5303L20.0303 7.53033C20.3232 7.23744 20.3232 6.76256 20.0303 6.46967C19.7374 6.17678 19.2626 6.17678 18.9697 6.46967L8.5 16.9393L4.53033 12.9697Z' fill='%23707070'/%3E%3C/svg%3E");
          mask-image: url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4.53033 12.9697C4.23744 12.6768 3.76256 12.6768 3.46967 12.9697C3.17678 13.2626 3.17678 13.7374 3.46967 14.0303L7.96967 18.5303C8.26256 18.8232 8.73744 18.8232 9.03033 18.5303L20.0303 7.53033C20.3232 7.23744 20.3232 6.76256 20.0303 6.46967C19.7374 6.17678 19.2626 6.17678 18.9697 6.46967L8.5 16.9393L4.53033 12.9697Z' fill='%23707070'/%3E%3C/svg%3E");
          mask-size: contain;
          -webkit-mask-size: contain;
          -webkit-mask-repeat: no-repeat;
          mask-repeat: no-repeat;
          -webkit-mask-position: center;
          mask-position: center;
        }
      }
    }
  }

  .accept {
    margin: 0;
    color: var(--verdocs-dialog-content-color, #424242);

    verdocs-checkbox {
      font-size: 14px;
      line-height: 20px;

      label > input[type='checkbox'] + * {
        display: flex;
        align-items: flex-start;
      }

      label > input[type='checkbox'] + *::before {
        width: 16px;
        height: 16px;
        line-height: 16px;
        margin-right: 12px;
        flex-shrink: 0;
        margin-top: 2px;
      }
    }
  }

  a {
    color: var(--verdocs-link-color, $verdocs-purple-shade);
  }

  .buttons {
    gap: 12px;
    display: flex;
    margin-top: 0;
    flex-direction: row;
    justify-content: flex-end;

    button {
      padding: 8px 16px;
      height: 40px;
      display: flex;
      font-size: 14px;
      font-weight: 400;
      cursor: pointer;
      align-items: center;
      border-radius: var(--verdocs-button-radius, 4px);
      justify-content: center;
      transition: all 0.2s ease;

      &.decline {
        margin-right: auto;
        background-color: transparent;
        border: var(--verdocs-button-secondary-border, 1px solid #d1d5db);
        color: var(--verdocs-button-secondary-color, #374151);

        &:hover {
          background-color: var(--verdocs-button-secondary-hover-bg, #f9fafb);
        }
      }

      &.delegate {
        background-color: transparent;
        border: var(--verdocs-button-secondary-border, 1px solid #d1d5db);
        color: var(--verdocs-button-secondary-color, #374151);
      }

      &.proceed {
        background-color: var(--verdocs-primary-color, $verdocs-green);
        border: 1px solid transparent;
        color: #ffffff;

        &:hover {
          background-color: var(--verdocs-primary-color-hover, $verdocs-green-shade);
        }
      }

      &:disabled {
        background-color: var(--verdocs-button-disabled-bg, #e5e7eb);
        color: var(--verdocs-button-disabled-color, #9ca3af);
        cursor: not-allowed;
      }
    }
  }
}
